<template>
  <div class="radio-with-icons">
    <div class="form-check input-icons input-icons-type">
      <input
        :id="idFor || radioValue"
        class="form-check-input"
        :disabled="disabled"
        :value="radioValue"
        @input="updateValue"
        type="radio"
        :checked="value == radioValue"
      />
      <label class="form-check-label" :class="variant" :for="idFor || radioValue">
        <div class="radio-with-icons__icon-wrapper row align-items-center">
          <div
            v-show="iconClass != 'none'"
            :class="{
              'col-md-4 col-sm-12': layout === 'horizontal',
              'col-md-12 col-sm-12 mb-2': layout === 'vertical',
            }"
          >
            <i :class="iconClass"></i>
          </div>
          <div
            class="no-select"
            :class="{
              'col-md-8 col-sm-12 text-md-left text-sm-center': layout === 'horizontal',
              'col-md-12 col-sm-12 text-center': layout === 'vertical',
            }"
          >
            <slot></slot>
          </div>
        </div>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RadioButtonTapWithIcon',
  props: {
    iconClass: String,
    layout: {
      type: String,
      default: 'horizontal',
    },
    variant: {
      type: String,
      default: 'primary',
      validator: function (value) {
        // The value must match one of these strings
        return ['success', 'warning', 'danger', 'info', 'secondary', 'primary'].indexOf(value) !== -1;
      },
    },
    value: String,
    radioValue: [String, Number],
    idFor: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    updateValue(e) {
      this.$emit('input', e.target.value);
    },
  },
};
</script>

<style scoped lang="scss">
.input-icons {
  height: 100%;

  input {
    display: none;
  }

  p {
    margin-bottom: 0;
  }

  input:checked + label.primary {
    border: 1px solid $primary;
    background: rgba($primary, 0.08);
    box-shadow: 0 0 0 0.2rem rgba($primary, 0.25);

    i {
      color: $primary;
    }
  }

  input:checked + label.secondary {
    border: 1px solid $secondary;
    background: rgba($secondary, 0.08);
    box-shadow: 0 0 0 0.2rem rgba($secondary, 0.25);

    i {
      color: $secondary;
    }
  }

  input:checked + label.info {
    border: 1px solid $info;
    background: rgba($info, 0.08);
    box-shadow: 0 0 0 0.2rem rgba($info, 0.25);

    i {
      color: $info;
    }
  }

  input:checked + label.danger {
    border: 1px solid $danger;
    background: rgba($danger, 0.08);
    box-shadow: 0 0 0 0.2rem rgba($danger, 0.25);

    i {
      color: $danger;
    }
  }

  input:checked + label.warning {
    border: 1px solid $warning;
    background: rgba($warning, 0.08);
    box-shadow: 0 0 0 0.2rem rgba($warning, 0.25);

    i {
      color: $warning;
    }
  }

  input:checked + label::before {
    width: 22px;
    height: 22px;

    background-image: url('../../../../../icons/custom/checkmark.svg');
    background-size: 12px;
    background-position: center center;
    background-repeat: no-repeat;
    border-radius: 50%;
    content: '';
    position: absolute;
    top: -10px;
    right: -10px;
  }

  input:checked + label.primary::before {
    background-color: $primary;
  }

  input:checked + label.secondary::before {
    background-color: $secondary;
  }

  input:checked + label.info::before {
    background-color: $info;
  }

  input:checked + label.danger::before {
    background-color: $danger;
  }

  input:checked + label.warning::before {
    background-color: $warning;
  }

  label {
    width: 100%;
    height: 100%;
    border: 1px solid $gray-400;
    border-radius: $border-radius;
    padding: 1rem 0.75rem;
    transition: all 0.2s;
    cursor: pointer;
  }

  label:hover {
    border-color: $husleie-green;
    background: rgba(0, 198, 134, 0.08);
    box-shadow: 0 0 0 0.2rem rgba(0, 198, 134, 0.25);

    i {
      color: $husleie-green;
    }
  }

  label i {
    font-size: 2.3rem;
  }

  .action-caption {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
}

.radio-with-icons__icon-wrapper {
  height: 100%;
}
</style>
